/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import {
  BUTTON_FORMAT_SOFT,
  BUTTON_THEME_DEFAULT,
  ButtonProps,
  DIALOG_SIZE_SM,
  DialogContentProps,
  DialogProps,
} from '@squiz/sds';
import { DialogLauncher } from 'apps/console-core/src/Components/DialogLauncher/DialogLauncher';
import { useDialogStore } from 'dxpConsoleCore-mf/State';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { FILE_EXPLORER_STRINGS } from '../../FileExplorer.constants';
import { CreateFolderDialogContent } from './elements/CreateFolderDialogContent/CreateFolderDialogContent';

export const CreateFolderDialogLauncher = (): JSX.Element => {
  const { t } = useTranslation();
  const labels = {
    createFolder: t(FILE_EXPLORER_STRINGS.createFolder),
    folderName: t(FILE_EXPLORER_STRINGS.folderName),
  };

  const createFolderButtonProps: ButtonProps = useMemo(
    () => ({
      classes: 'file-explorer__create-folder-button',
      format: BUTTON_FORMAT_SOFT,
      text: labels.createFolder,
      theme: BUTTON_THEME_DEFAULT,
    }),
    [labels.createFolder],
  );

  const createFolderDialogProps: DialogProps = useMemo(
    () => ({
      classes: 'file-explorer__dialog create-folder',
      dialogContent: {
        renderContent: (props: DialogContentProps) => <CreateFolderDialogContent {...props} />,
      },
      dialogSize: DIALOG_SIZE_SM,
      heading: labels.createFolder,
      stateHandler: useDialogStore,
    }),
    [labels.createFolder],
  );
  return <DialogLauncher buttonProps={createFolderButtonProps} dialogProps={createFolderDialogProps} />;
};
